const ConsultationStatus = {
  ConsultationConfirmed: 'ConsultationConfirmed',
  ConsultationNeedsReschedule: 'ConsultationNeedsReschedule',
  ConsultationCanceled: 'ConsultationCanceled',
};

export default ConsultationStatus;
